/* eslint-disable ember/no-classic-components, ember/require-tagless-components */
import Component from '@ember/component';

export default class Drawer extends Component {
  // passed in
  isOpen = false;

  title = null;
  description = null;
  onClose = null;
  onSave = null;
  saveLabel = 'Save';
  isSaveDisabled = false;
  isLoading = false;
}
